import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FacadeService } from 'src/app/shared/service-facade/facade.service';

@Component({
  selector: 'app-docusign-fail',
  templateUrl: './docusign-fail.component.html',
  styleUrls: ['./docusign-fail.component.css']
})
export class DocusignFailComponent implements OnInit {

  envelopeId : string = "";
  destinationEmail : string = "";

  constructor(private router: ActivatedRoute,
              private facadeService : FacadeService)
    { }

  ngOnInit(): void {
    let id =  this.router.snapshot.queryParamMap.get('envId');
    let destinationEmail =  this.router.snapshot.queryParamMap.get('destEmail');

    if (typeof(id) === 'string') {
      this.envelopeId = id;
    }

    if (typeof(destinationEmail) === 'string') {
      this.destinationEmail = destinationEmail;
    }

      this.facadeService.showErrorPage(this.destinationEmail + " signing process failure for " + this.envelopeId, "DocuSign Signing Failure");
  }
}
